module.exports = __webpack_public_path__ + "static/jared-kaneshiro_resume-cac2970be55fd0a80db9f43dc123553d.pdf";